import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class MaintenanceInterventionTypesAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: { message: '', type: '', status: 'open' },
      redirect_url: false,
      loaded: 0,
      aircraft_model_id: null,
      type: '',
      aircraft_models_select: [],
    };
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
  }
  handleChange (name, event) {
    var change = {}; change[name] = event.target.value; this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {}; change[name] = event ? event.value : null; this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') { this.setState({overlay: {message: '', type: '', status: 'closed'}}); }
    else { this.setState({overlay: {message: message, type: type, status: status}}); }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message) { message = JSON.parse(message); this.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}}); localStorage.removeItem("verify_message"); }
  }
  handleLoaded(state) { if(this.state.loaded !== 2) { this.setState({loaded: state}); } }
  componentDidMount () { this.refs.request_api.header(); }
  componentDidUpdate(prevProps, prevState) { if(this.state.loaded === 1 && prevState.loaded === 0) { this.setState({loaded: 2}, this.loadData()); } }
  loadData () {
    var self = this; var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo/lista', { method: 'GET', mode: 'cors', headers: value }).then((r) => r.json()).catch((e) => { console.error(e); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') { self.setState({ aircraft_models_select: responseJson.data }); }
      }).then(() => { self.setState({overlay: {message: '', type: '', status: 'closed'}}); self.handleMessage(); });
    });
  }
  add(event) {
    event.preventDefault();
    var datasave = { aircraft_model_id: this.state.aircraft_model_id, type: this.state.type };
    var self = this; var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/manutencao/intervencao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((r) => r.json()).catch((e) => { console.error(e); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/manutencao/intervencao/editar/' + responseJson.data.id;
          localStorage.setItem("verify_message", JSON.stringify({ alert_message: responseJson.message, alert_type: responseJson.status }));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      });
    });
  }
  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar Tipo de Intervenção de Manutenção</h3>
      <Link to="/manutencao/intervencoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6"><div className="form-group">
            <label>Modelo:</label>
            <Select className="form-field-name" name="aircraft_model_id" value={this.state.aircraft_model_id} searchable={true} placeholder={''} onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')} options={this.state.aircraft_models_select} />
          </div></div>
          <div className="col-md-6"><div className="form-group">
            <label>Tipo:</label>
            <input type="text" className="form-control" name="type" value={this.state.type} onChange={this.handleChange.bind(this, 'type')} />
          </div></div>
        </div>
        <div className="row"><div className="col-md-12">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
        </div></div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default MaintenanceInterventionTypesAdd;



// WEBPACK FOOTER //
// ./src/Components/MaintenanceInterventionTypes/MaintenanceInterventionTypesAdd.js